import { useTransform } from 'framer-motion'
import { useYpos } from 'lib/hooks/use-ypos'
import { maxWidth } from 'constants/styles'
import Image from 'components/Image'
import { parallax } from 'constants/easings'
import { useScrollerMotion } from 'scroller-motion'

type Props = {
	title?: string,
	text: any
	image: string
	align?: 'left'|'right'|'left top'|'right top'
}

export default function TextImageHalf({ title, text, image, align }: Props ) {
	const { scrollY } = useScrollerMotion()
	const { ref, start, stop } = useYpos()
	const y = useTransform( scrollY, [ start, stop ], [ '0%', `-${parallax}%` ] )

	return (
		<section ref={ref} className={`container ${align || 'right top'}`}>
			{!!title && <h2>{title}</h2>}
			<div>
				<picture>
					<Image
						src={image}
						loading="lazy"
						sizes={`( min-width: 1170px ) ${Math.ceil( 585 * 1.05 )}px, 90vw`}
						style={{ y, scale: 1.05, transformOrigin: '50% 0%' }}
					/>
				</picture>
				<div className="text">{text}</div>
			</div>
			<style jsx>{`
				h2 {
					margin-bottom: 100px;
				}
				@media ( max-width: 900px ) {
					h2 {
						margin-bottom: 76px;
					}
				}
				@media ( max-width: 500px ) {
					h2 {
						margin-bottom: 50px;
					}
				}
				section > div {
					display: flex;
				}
				section .text {
					flex: 1;
				}
				section .text :global( h3 ) {
					margin-right: 1em;
				}
				section .text :global( p ) {
					margin-right: 2em;
				}
				div picture {
					width: 50%;
				}
				div picture :global( img ) {
					min-height: 100px; /* to make sure browser loads image */
				}

				section:not( .top ) > div {
					align-items: center;
				}
				section.left .text {
					padding-left: ${( maxWidth / 12 ) * 1.5}px;
					padding-right: ${( maxWidth / 12 ) * .5}px;
				}
				section.right > div {
					flex-direction: row-reverse;
				}
				section.right .text {
					padding-right: ${( maxWidth / 12 ) * 1.5}px;
				}

				@media ( max-width: 900px ) {
					section > div {
						flex-wrap: wrap-reverse;
					}
					div picture {
						width: 100%;
						margin-top: 60px;
					}
					section.left .text,
					section.right .text {
						width: 100%;
						padding-left: 0;
						padding-right: 0;
					}

					section .text :global( h3 ),
					section .text :global( p ) {
						margin-right: 0;
					}
				}
			`}</style>
		</section>
	)
}
